import React from 'react';
import { useNavigate } from 'react-router-dom';

const UserFriendlyNotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {/* 404 Illustration */}
        <div className="mb-8">
          <div className="text-8xl mb-4">🔍</div>
          <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">
            Page Not Found
          </h2>
          <p className="text-gray-600 mb-8">
            Oops! The page you're looking for doesn't exist. 
            It might have been moved, deleted, or you entered the wrong URL.
          </p>
        </div>

        {/* Helpful Suggestions */}
        <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
          <h3 className="text-lg font-medium text-gray-900 mb-4">
            Here's what you can do:
          </h3>
          <div className="space-y-3 text-left">
            <div className="flex items-center">
              <span className="text-green-500 mr-3">✓</span>
              <span className="text-sm text-gray-600">Check the URL for typos</span>
            </div>
            <div className="flex items-center">
              <span className="text-green-500 mr-3">✓</span>
              <span className="text-sm text-gray-600">Go back to the previous page</span>
            </div>
            <div className="flex items-center">
              <span className="text-green-500 mr-3">✓</span>
              <span className="text-sm text-gray-600">Visit our homepage</span>
            </div>
            <div className="flex items-center">
              <span className="text-green-500 mr-3">✓</span>
              <span className="text-sm text-gray-600">Contact support if you need help</span>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="space-y-4">
          <button
            onClick={handleGoHome}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
          >
            🏠 Go to Homepage
          </button>
          
          <button
            onClick={handleGoBack}
            className="w-full bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-3 px-6 rounded-lg transition-colors"
          >
            ← Go Back
          </button>

          <div className="pt-4">
            <p className="text-sm text-gray-500 mb-2">Need assistance?</p>
            <a 
              href="mailto:support@axel.com"
              className="text-blue-600 hover:text-blue-800 text-sm font-medium"
            >
              📧 Contact Support
            </a>
          </div>
        </div>

        {/* Popular Links */}
        <div className="mt-8 pt-8 border-t border-gray-200">
          <h4 className="text-sm font-medium text-gray-700 mb-4">Popular Pages</h4>
          <div className="flex flex-wrap justify-center gap-4">
            <button
              onClick={() => navigate('/dashboard')}
              className="text-blue-600 hover:text-blue-800 text-sm"
            >
              Dashboard
            </button>
            <button
              onClick={() => navigate('/packages')}
              className="text-blue-600 hover:text-blue-800 text-sm"
            >
              Packages
            </button>
            <button
              onClick={() => navigate('/submissions')}
              className="text-blue-600 hover:text-blue-800 text-sm"
            >
              Submissions
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserFriendlyNotFound;
